// @flow
import { httpClient } from 'angieslist-app-platform';

async function getAdvertisingArea(serviceProviderId: string | number):
Promise<{|requestType: string, response: any|}> {
  return {
    requestType: 'advertisingArea',
    response: await httpClient.get(`/gateway/office-home/v1/service_providers/${serviceProviderId}/advertisingPostalCodes `, {
      headers: {
        'X-ANGI-CallerId': serviceProviderId,
      },
    }),
  };
}

async function getServiceArea(serviceProviderId: string | number):
Promise<{|requestType: string, response: any|}> {
  return {
    requestType: 'serviceArea',
    response: await httpClient.get(`/gateway/office-home/v1/service_providers/${serviceProviderId}/service_areas `, {
      headers: {
        'X-ANGI-CallerId': serviceProviderId,
      },
    }),
  };
}

async function getServiceAreaWithOneTimeToken(spId: string | number, oneTimeToken: string):
Promise<{|requestType: string, response: any|}> {
  return {
    requestType: 'serviceArea',
    response: await httpClient.get(`/gateway/office-home/v1/service_providers/${spId}/service_areas `, {
      headers: {
        'X-ANGI-CallerId': spId,
        Authorization: 'OneTime '.concat(oneTimeToken),
      },
    }),
  };
}

const searchCities = (query: string): any => {
  const splitQuery = query.split(',');
  const baseParams = {
    query: splitQuery[0].toLowerCase(),
    limit: 50,
  };
  const stateParam = splitQuery.length > 1 && splitQuery[1].trim().length > 0 ?
    { state: splitQuery[1].trim().toLowerCase() } : {};
  const params = { ...baseParams, ...stateParam };

  return httpClient.get('/gateway/office-home/v1/city/suggestions', { params });
};

const getCityDetails = (serviceProviderId: string | number, cityId: number): any =>
  httpClient.post('/gateway/office-home/v1/postal_codes/get-by-city-id', {
    headers: {
      'X-ANGI-CallerId': serviceProviderId,
    },
    body: {
      cityId,
    },
  });

const setServiceArea = (serviceProviderId: string | number, postalCodes: string[]): any =>
  httpClient.post(`/gateway/office-home/v1/service_providers/${serviceProviderId}/service_areas `, {
    headers: {
      'X-ANGI-CallerId': serviceProviderId,
    },
    body: {
      postalCodes,
    },
  });

export default {
  getAdvertisingArea,
  getServiceArea,
  getServiceAreaWithOneTimeToken,
  searchCities,
  getCityDetails,
  setServiceArea,
};



// WEBPACK FOOTER //
// ./src/app/common/service-area/serviceAreaMapService.js